import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutPage from "./pages/AboutPage";
import LandingPage from "./pages/LandingPage"; // Import the LandingPage component
import CountiesPage from "./pages/CountiesPage";
import CountyDetailPage from "./pages/CountyDetailPage";
import NonProfitsPage from "./pages/NonProfitsPage";
import NonprofitDetailPage from "./pages/NonProfitsDetail";
import HealthCentersPage from "./pages/HealthCentersPage";
import CenterDetailPage from "./pages/CenterDetailPage";
import NavigationBar from "./components/NavigationBar";
import SearchAll from "./pages/SearchAll";

function App() {
  return (
    <>
      <Router>
        <NavigationBar></NavigationBar>
        <Routes>
          <Route index element={<LandingPage />} />
          <Route path="counties" element={<CountiesPage />} />
          <Route path="counties/:id" element={<CountyDetailPage />} />
          <Route path="nonprofits" element={<NonProfitsPage />} />
          <Route path="nonprofits/:id" element={<NonprofitDetailPage />} />
          <Route path="healthcenters" element={<HealthCentersPage />} />
          <Route path="healthcenters/:id" element={<CenterDetailPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="search/:term" element={<SearchAll />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
